import {API} from '../../networking/http'
import {QueryMethod} from '../helpers/types'

export type GetAppearanceBaseSettingsParams = {
  id?: string
}
export type GetAppearanceBaseSettingsQueryParams = undefined
export type AppearanceBaseSettingsType = {
  title: string
  showSchedule?: boolean
  // D257: a CSS colour painted behind the whole venue page instead of the cover photo; null/absent = default
  pageBackgroundColor?: string | null
}

export type GetAppearanceBaseSettingsQuery = QueryMethod<
  GetAppearanceBaseSettingsParams,
  GetAppearanceBaseSettingsQueryParams,
  // @ts-ignore
  AppearanceBaseSettingsType,
>

const defaultCacheTime: number = 1000 * 300 * 1000

export const makeGetAppearanceBaseSettingsEndpoint = ({id}: GetAppearanceBaseSettingsParams) => `displaySettings/appearance-template/${id}`

export const getAppearanceBaseSettingsQuery: GetAppearanceBaseSettingsQuery = ({query, params, cacheTime = defaultCacheTime}) => ({
  cacheTime,
  refetchOnWindowFocus: false,
  queryKey: [`getAppearanceBaseSettingsQuery-${params?.id || ''}`, query],
  queryFn: ({queryKey: [_, config]}) => {
    if (params?.id) {
      return API.get<GetAppearanceBaseSettingsQueryParams, AppearanceBaseSettingsType>(makeGetAppearanceBaseSettingsEndpoint(params), {
        params: config,
      }).then((res) => res.data)
    }
    return new Promise((res) => res({
      title: 'Default'
    }))
  }
})
